import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.setSrc(this.element);
  }

  setSrc(element) {
    setTimeout(()=>{element.setAttribute("loading", "eager"); element.setAttribute("src", element.dataset.src)}, 2000) ;
  }

  setNext(event) {
    $(event.target)
      .next("turbo-frame")
      .attr("data-controller", "lazy-frame-list");
  }
}
